/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchLobbyMemberResponse } from './MatchLobbyMemberResponse';
import {
    MatchLobbyMemberResponseFromJSON,
    MatchLobbyMemberResponseFromJSONTyped,
    MatchLobbyMemberResponseToJSON,
    MatchLobbyMemberResponseToJSONTyped,
} from './MatchLobbyMemberResponse';

/**
 * 
 * @export
 * @interface MatchLobbyTeamResponse
 */
export interface MatchLobbyTeamResponse {
    /**
     * 
     * @type {string}
     * @memberof MatchLobbyTeamResponse
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof MatchLobbyTeamResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MatchLobbyTeamResponse
     */
    tag?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchLobbyTeamResponse
     */
    seed?: number;
    /**
     * Whether this team hosts the in-game lobby (participant1 / the team on the left).
     * @type {boolean}
     * @memberof MatchLobbyTeamResponse
     */
    isHost: boolean;
    /**
     * Team-level readiness for the match.
     * @type {boolean}
     * @memberof MatchLobbyTeamResponse
     */
    ready: boolean;
    /**
     * 
     * @type {Array<MatchLobbyMemberResponse>}
     * @memberof MatchLobbyTeamResponse
     */
    members: Array<MatchLobbyMemberResponse>;
}

/**
 * Check if a given object implements the MatchLobbyTeamResponse interface.
 */
export function instanceOfMatchLobbyTeamResponse(value: object): value is MatchLobbyTeamResponse {
    if (!('teamId' in value) || value['teamId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isHost' in value) || value['isHost'] === undefined) return false;
    if (!('ready' in value) || value['ready'] === undefined) return false;
    if (!('members' in value) || value['members'] === undefined) return false;
    return true;
}

export function MatchLobbyTeamResponseFromJSON(json: any): MatchLobbyTeamResponse {
    return MatchLobbyTeamResponseFromJSONTyped(json, false);
}

export function MatchLobbyTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchLobbyTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'teamId': json['teamId'],
        'name': json['name'],
        'tag': json['tag'] == null ? undefined : json['tag'],
        'seed': json['seed'] == null ? undefined : json['seed'],
        'isHost': json['isHost'],
        'ready': json['ready'],
        'members': ((json['members'] as Array<any>).map(MatchLobbyMemberResponseFromJSON)),
    };
}

export function MatchLobbyTeamResponseToJSON(json: any): MatchLobbyTeamResponse {
    return MatchLobbyTeamResponseToJSONTyped(json, false);
}

export function MatchLobbyTeamResponseToJSONTyped(value?: MatchLobbyTeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamId': value['teamId'],
        'name': value['name'],
        'tag': value['tag'],
        'seed': value['seed'],
        'isHost': value['isHost'],
        'ready': value['ready'],
        'members': ((value['members'] as Array<any>).map(MatchLobbyMemberResponseToJSON)),
    };
}

